import React, { useState, useEffect } from "react";
import {
    Button,
    Modal,
    Row,
    Col,
    Input,
    Empty,
    Alert,
    Dropdown,
    Space,
    Tag,
    Radio,
    Tooltip
} from "antd";
import { InfoCircleOutlined } from '@ant-design/icons';
import "./PlaceBidModal.css";
import CandidateCard from "./CandidateCard/CandidateCard";
import JobCard from "../../components/JobCard/JobCard";
import BidAmount from "./BidAmount/BidAmount";
import { connect, useDispatch, useSelector } from "react-redux";
import { SellJob } from "./SellJob/SellJob";
import FinalizeBid from "./FinalizeBid/FinalizeBid";
import noJobs from "../../assets/img/EmptyInterviews.png";
import history from "../../routes/history";
import PayCalculation from "./payCalculation";
import { HttpLink } from "apollo-link-http";
import { setContext } from "@apollo/client/link/context";
import {
    ApolloClient,
    InMemoryCache,
    ApolloProvider,
    useQuery,
    ApolloLink,
    gql,
} from "@apollo/client";

import {
    getJobListing,
    jobListingRESET,
    getJobCounts,
    savePropsPlaceBid,
} from "../../redux/actions";
import {
    SearchOutlined,
    LoadingOutlined,
    DownOutlined,
} from "@ant-design/icons";
import { getImageByStateCode } from "../../pages/CompanyProfile/components/cloudinary";
import {
    createBid,
    createMultiBid,
    updateBid,
    clearBidSucess,
    fetchInboxMessages,
    fetchMessagesCounts,
} from "../../redux/actions";
import InfiniteScroll from "react-infinite-scroll-component";
import { debounce } from "redux-saga/effects";
import AllGigsFilter from "../../pages/SearchSkillListing/components/AllGigs/AllGigsFilter";
import ChooseGigsButton from "./ChooseGigsButton";
import MobileViewFilter from "./MobileViewFilter";
import { useLocation } from "react-router-dom";
import { GIGS_QUERY } from "./gigsQuery";
import { DEFAULT_FILTER_VALUES } from "./PlaceBidModal";
import { useLazyQuery } from "@apollo/client";
import { calculateTalentNetPay } from "./utils";
import Taxtermicon from "../../assets/icons/Taxtermicon.svg"
const skillGigPercentage = 10;
const payRollCostForCorpToCorp = 5;
const payRollCostForW2 = 18;


export function PlacedBidModalPage() {
    const props = useSelector(
        (state) => state.favoritesReducer.placeBidData
    );
    const location = useLocation();
    const talentName = location.state?.talentName
    const dispatch = useDispatch();
    const loadingBidCreate = useSelector(
        (state) => state.createBidReducers.loading
    );
    const successBidCreate = useSelector(
        (state) => state.createBidReducers.success
    );
    const sucessBidUpdate = useSelector(
        (state) => state.updateBidReducers.success
    );
    const loadingBidUpdate = useSelector(
        (state) => state.updateBidReducers.loading
    );
    const counts = useSelector((state) => state.manageJobsReducer.counts);
    const jobLoading = useSelector((state) => state.manageJobsReducer.loading);

    const bidData = useSelector((state) => state.createBidReducers.bidData);
    const authTokenValue = useSelector(
        (state) => state.authReducer.user.authToken
    );
    const updatedBidData = useSelector(
        (state) => state.updateBidReducers.success
    );

    const createBidError = useSelector((state) => state.createBidReducers.error);

    const updateBidError = useSelector((state) => state.updateBidReducers.error);

    const [modalType, setmodalType] = useState("Place a bids");
    // const [isModalVisible, setIsModalVisible] = useState(props.visible);
    const [sorttype, setsorttype] = useState("$");
    const [searchPublish, setsearchPublish] = useState([]);
    const [selectedGigDetails, setselectedGigDetails] = useState(
        props?.jobdetails?.length && props?.jobdetails[0]
    );
    const [message, setmessage] = useState();
    const [Comments, setComments] = useState();
    const [rateType, setrateType] = useState("");
    const [rate, setrate] = useState(0.0);
    const [multiBid, setmultiBid] = useState();
    const [currencyType, setcurrencyType] = useState("USD");
    const [contractLength, setcontractLength] = useState("");
    const [idealStartDate, setidealStartDate] = useState();
    const [error1, setError1] = useState("");
    const [error2, setError2] = useState("");
    const [error3, setError3] = useState("");
    const [msgCounter, setMsgCounter] = useState(0);
    const [flag, setFlag] = useState(false);
    const [taxTermRadio, setTaxTermRadio] = useState("W-2");

    const [rateError, setRateError] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [totalLength, setTotalLength] = useState(false);
    const [gigAlert, setGigAlert] = useState(false);
    const [errorAlert, setErrorAlert] = useState(false);
    const [GigType, setGigType] = useState(false);
    const [Editgig2, setEditgig2] = useState(false);
    const [searchFilters, setSearchFilters] = useState({
        DEFAULT_FILTER_VALUES,
    });
    
    const [getGigs, { loading: loadingGigs, error, data }] =
        useLazyQuery(GIGS_QUERY);
    let userProfile = JSON.parse(localStorage.getItem("userProfile"));

    const [windowDimensions, setWindowDimensions] = useState(
        getWindowDimensions()
    );
    const professionCode = JSON.parse(localStorage.getItem("userProfile"));
    useEffect(() => {
        props.Title ? setmodalType(props.Title) : setmodalType("Place a bid");
        props.EditBid === true
            ? setmodalType("Edit Bid")
            : setmodalType("Place a bid");
    }, []);

    useEffect(() => {
        if (modalType !== "Place a bid" && (successBidCreate || sucessBidUpdate)) {
            setmodalType("Finalize Bid");
        }
    }, [successBidCreate, sucessBidUpdate]);

    useEffect(() => {
        if (props?.extendBilling) {
            setmodalType("Add Estimated Pay");
        }
    }, [props?.extendBilling]);

    useEffect(() => {
        setComments(message);
    }, [message]);

    useEffect(() => {
        if (errorAlert || createBidError || updateBidError) {
            setTimeout(() => {
                closemeHandle();
            }, 2000);
        }
    }, [errorAlert, createBidError, updateBidError]);

    useEffect(() => {
        if (contractLength?.length < 0) {
            setError1("Please enter contract length");
        } else {
            setError1(" ");
        }
    }, [contractLength]);

    useEffect(() => {
        if (idealStartDate?.length < 0) {
            setError2("Please select ideal start date");
        } else {
            setError2(" ");
        }
    }, [idealStartDate]);

    useEffect(() => {
        if (props.selectedCandidates?.length == 0 && props.fromMatches != true) {
            props?.placeBidModalVisisblityHandler(false);
        }
    }, [props.selectedCandidates]);

    useEffect(() => {
        if (props.selectedCandidates?.length > 0) {
            if (props.selectedCandidates?.length > 1) {
                setmultiBid(true);
                setrate(0);
            } else {
                setmultiBid(false);
                setrate(
                    professionCode?.Professions?.ProfessionCode == "IT"
                        ? 1.0
                        : props.selectedCandidates[0]?.desired_rate
                );
            }
        }
    }, [props.selectedCandidates]);

    useEffect(() => {
        setidealStartDate(
            idealStartDate
                ? idealStartDate
                : props.EditBid
                    ? props.IdealStartDate
                    : ""
        );
        setrateType(rateType ? rateType : props.EditBid ? props.rateType : "");
        setcontractLength(
            contractLength
                ? contractLength
                : props.EditBid
                    ? props.IdealConLength
                    : ""
        );
        setmessage(message ? message : props.EditBid ? props.Description : "");
        setrate(
            professionCode?.Professions?.ProfessionCode == "IT"
                ? props.Bid_rate ?? 1
                : props.EditBid
                    ? props.Bid_rate
                    : props.desired_rate
                        ? props.desired_rate
                        : 1
        );
    }, [props]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (props.selectedCandidates?.length > 0) {
            if (props.selectedCandidates?.length > 1) {
                setmultiBid(true);
                setrate(0);
            } else {
                setmultiBid(false);
                setrate(
                    professionCode?.Professions?.ProfessionCode == "IT"
                        ? 1.0
                        : props.selectedCandidates[0]?.desired_rate
                );
            }
        }
    }, [props.selectedCandidates]);

    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
            width,
            height,
        };
    }

    const jobs = useSelector((state) => state.manageJobsReducer.jobs);
    const publishedJobs = useSelector(
        (state) => state.manageJobsReducer.publishedJobs
    );
    useEffect(() => {
        dispatch(jobListingRESET());
    }, [successBidCreate, sucessBidUpdate]);

    useEffect(() => {
        if (true) {
            debounce(
                dispatch(
                    getJobListing({
                        sorttype: sorttype,
                        currentPage: 1,
                        pageSize: 20,
                        gigType: "Published",
                        inputSearch: searchText,
                        totalLength: totalLength,
                        isPrivate: GigType,
                    })
                )
            );
            // debounce(
            //     dispatch(
            //         getJobCounts({
            //             inputSearch: searchText == " " ? "$" : searchText,
            //         })
            //     )
            // );
        }
        setTotalLength(true);
    }, [searchText, props.visible, GigType]);

    useEffect(() => {
        if (props?.BidId) {
            dispatch(savePropsPlaceBid(props));
        }
    }, [props?.BidId]);
    useEffect(() => {
        if (publishedJobs?.length !== 0) {
            let uniqueJobs = {};
            let filteredJobs = data?.gigs?.data?.filter((obj) => {
                if (!uniqueJobs[obj._id]) {
                    uniqueJobs[obj._id] = true;
                    return true;
                }
                return false;
            });
            setsearchPublish(filteredJobs);
        }
        
        if (data?.gigs?.data?.length == 20) {
            setHasMore(true);
        }
    }, [data?.gigs?.data, props.visible]);
    const backHandler = () => {
        if (modalType === "Place a bid" || modalType == "Edit Bid") {
            props.placeBidModalVisisblityHandler(false);
            setErrorAlert(false);
            props?.setHidePagePvt(false);
        }
        if (modalType === "Choose a gig") {
            setmodalType("Place a bid");
            setErrorAlert(false);
            props?.setHidePagePvt(false);
            setSearchFilters(DEFAULT_FILTER_VALUES);
        }

        if (modalType === "Add Estimated Pay") {
            if (props.fromMatches == true) {
                setmodalType("Place a bid");
                setErrorAlert(false);
            } else {
                if(userProfile?.Professions?.ProfessionCode === "IT"){
                    setmodalType("");
                    showTaxTermModal()
                    }
                    else{
                      setmodalType("Choose a gig");
                      setErrorAlert(false);
                      props?.setHidePagePvt(true);
                    }
            }
        }
        if (modalType === "Sell your gig") {
            setmodalType("Add Estimated Pay");
            setErrorAlert(false);
        }
        if (modalType === "Finalize Bid") {
            closemeHandle();
            dispatch(fetchInboxMessages("null", "all_conversations", "null", 1, 5));
            setTimeout(() => {
                dispatch(fetchInboxMessages("null", "all_conversations", "null", 2, 5));
            }, 2000);
        }
        if(!Editgig2){
            history.push(`/profiledetail/${props?.SkillListingId}`);
        }
    };
    const handleApplyFilter = (filters = {}) => {
        try {
            const {
                all,
                cities,
                countries,
                regions,
                Skills,
                explevel,
                isPrivateGig,
                JobOrderTypeName,
                _sort,
            } = filters;
            getGigs({
                variables: {
                    all: all || "",
                    cities: cities?.length ? cities : undefined,
                    countries: countries?.length ? countries : undefined,
                    regions: regions?.length ? regions : undefined,
                    Skills: Skills?.length ? Skills : undefined,
                    isPrivateGig,
                    MygigsProfileId: userProfile?.MasterAccountId || userProfile?.AccountId,
                    _page: "1",
                    _perPage: 24,
                    _sort: _sort || "MOST_RECENT",
                    explevel: explevel || undefined,
                    JobOrderTypeName: JobOrderTypeName || undefined,
                },
            });
        } catch (error) {
            console.warn("error", error);
        }
    };
    
    const nextHandler = () => {
        const { skillGiggFee, payrollCost, netGrossPay, grossPay } =
            calculateTalentNetPay({
                amount: rate,
                skillGigPercentage,
                payrollCostPercentage: taxTermRadio == "W-2" ? payRollCostForW2 : payRollCostForCorpToCorp,
            });
        setEditgig2(true);
        if (modalType === "Place a bid" || modalType == "Edit Bid") {
            if (props.fromMatches == true) {
                setmodalType("Add Estimated Pay");
                setErrorAlert(false);
            } else {
                if(userProfile?.Professions?.ProfessionCode === "IT"){
                    setmodalType("");
                    showTaxTermModal();
                    props?.setHidePagePvt(true);
                    setErrorAlert(false);
                    setSearchFilters(DEFAULT_FILTER_VALUES);
                    setSearchText("");
                    setGigType(false);
                  }
                  else{
                    setmodalType("Add Estimated Pay");
                    props?.setHidePagePvt(true);
                    setErrorAlert(false);
                    setSearchFilters(DEFAULT_FILTER_VALUES);
                    setSearchText("");
                    setGigType(false);
                  }
            }
            if (props?.EditBid) {
                setEditgig2(true);
            }
        }
        if (modalType === "Choose a gig") {
            if(userProfile?.Professions?.ProfessionCode === "IT"){
                setmodalType("");
                showTaxTermModal()
                setErrorAlert(false);
                props?.setHidePagePvt(false);
              }
              else{
                setmodalType("Add Estimated Pay");
              }
        }
        if (modalType === "Add Estimated Pay") {
            if (rateError === 0) {
                setmodalType("Sell your gig");
            }
            setErrorAlert(false);
        }
        if (modalType === "Sell your gig") {
            var errorCount = 0;

            if (
                contractLength?.length < 1 &&
                selectedGigDetails?.JobOrderTypes?.JobOrderTypeName === "Contract"
            ) {
                setError1("Please enter contract length");
                errorCount++;
            } else {
                setcontractLength(null);
            }

            if (idealStartDate?.length < 1) {
                setError2("Please select ideal start date");
                errorCount++;
            }

            if (msgCounter < 1) {
                setError3("Please add a message");
                errorCount++;
            }

            if (props.EditBid) {
                if (props?.SkillListingId == null) {
                    setErrorAlert(true);
                }
            } else if (!props.EditBid) {
                if (props?.selectedCandidates[0]?.id == null) {
                    setErrorAlert(true);
                }
            }

            if (
                !props.multiBid &&
                props.EditBid &&
                // rate >= props.desired_rate &&
                errorCount === 0 &&
                props?.SkillListingId != null
            ) {
                dispatch(
                    updateBid({
                        id: props.BidId,
                        GigId: selectedGigDetails?.JobOrderId
                            ? selectedGigDetails?.JobOrderId
                            : props.jobId,
                        SGFees:
                            selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "C" &&
                                professionCode?.Professions?.ProfessionCode == "IT" &&
                                userProfile?.Profiles?.Role !== "No billing"
                                ? 0.6899
                                : null,
                        ActualRate:
                            selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "C" &&
                                professionCode?.Professions?.ProfessionCode == "IT" &&
                                userProfile?.Profiles?.Role !== "No billing"
                                ? (rateType == "Year" ? (rate * 0.6899)?.toFixed(2) : parseFloat(netGrossPay)?.toFixed(2))
                                : rate,
                        SkillListingId: props?.SkillListingId,
                        Comments: message,
                        BudgetType: rateType,
                        BidStatusName: "New",
                        Rate: rate,
                        IdealTerm: contractLength,
                        IdealStartDate: idealStartDate,
                        Message: message + "\nBid Amount: " + rate,
                        loading: "Submitted",
                        IdealTermsName: taxTermRadio != "W-2" ? "1099/Corp-to-Corp" : taxTermRadio,
                    })
                );
            }
            if (
                !props.multiBid &&
                !props.EditBid &&
                errorCount === 0 &&
                props?.selectedCandidates[0]?.id != null
            ) {
                const permanentJob =
                    selectedGigDetails?.JobOrderTypes?.JobOrderTypeName !== "Contract";
                dispatch(
                    createBid(
                        selectedGigDetails?.JobOrderId
                            ? selectedGigDetails.JobOrderId
                            : props.jobId,
                        selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "C" &&
                            professionCode?.Professions?.ProfessionCode == "IT" &&
                            userProfile?.Profiles?.Role !== "No billing"
                            ? 0.6899
                            : null,
                        selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "C" &&
                            professionCode?.Professions?.ProfessionCode == "IT" &&
                            userProfile?.Profiles?.Role !== "No billing"
                            ? parseFloat(netGrossPay)?.toFixed(2)
                            : rate,
                        props.selectedCandidates[0].id,
                        Comments,
                        rateType,
                        message + "\nBid Amount: " + rate,
                        "New",
                        rate,
                        contractLength,
                        idealStartDate,
                        permanentJob
                    )
                );
            }
            if (props.multiBid && errorCount === 0) {
                var candidateListArray = props.selectedCandidates?.map((item) => {
                    return {
                        GigId: selectedGigDetails?.JobOrderId
                            ? selectedGigDetails?.JobOrderId
                            : props.jobId,
                        SGFees: selectedGigDetails?.JobOrderTypes?.JobOrderTypeId
                            ? selectedGigDetails?.JobOrderTypes?.JobOrderTypeId === 1
                            : selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "C" &&
                                !userProfile?.Profiles?.BidCalculationExempted
                                ? 0.6899
                                : null,
                        ActualRate:
                            selectedGigDetails?.JobOrderTypes?.JobOrderTypeCode === "C" &&
                                professionCode?.Professions?.ProfessionCode == "IT" &&
                                userProfile?.Profiles?.Role !== "No billing"
                                ? parseFloat(netGrossPay)?.toFixed(2)
                                : rate,
                        SkillListingId: item.id,
                        Comments: message,
                        BudgetType: rateType,
                        Message: message + "\nBid Amount: " + rate,
                        BidStatusName: "New",
                        Rate: rate,
                        IdealTerm: contractLength,
                        IdealStartDate: idealStartDate,
                    };
                });

                dispatch(
                    createMultiBid({
                        bids: candidateListArray,
                    })
                );
            }
        }

        if (modalType === "Finalize Bid") {
            props.placeBidModalVisisblityHandler(false);
            dispatch(fetchInboxMessages("null", "all_conversations", "null", 1, 5));
            setTimeout(() => {
                dispatch(fetchInboxMessages("null", "all_conversations", "null", 2, 5));
            }, 2000);
            if (props.setSkillListingIds && props.setcheckAllClicked) {
                props.setSkillListingIds([]);
                props.setcheckAllClicked(false);
            }
            if (!(props?.frompdetail || props?.fromMyMatches)) {
                window.location.reload();
            }
            closemeHandle();
        }
    };

    const closemeHandle = () => {
        if (modalType === "Finalize Bid") {
            if (props.EditBid && location.pathname == "/editPlaceBidPage") {
                history.push(`/profiledetail/${props?.SkillListingId}`);
            }
            localStorage.removeItem("SelectedSkills");
            localStorage.removeItem("SelectedSkillsSearch");
            props.placeBidModalVisisblityHandler(false);
            if (props.setSkillListingIds && props.setcheckAllClicked) {
                props.setSkillListingIds([]);
                props.setcheckAllClicked(false);
            }
            window.location.reload();
        } else {
            props.placeBidModalVisisblityHandler(false);
            dispatch(clearBidSucess());
            setSearchText("");
            setcontractLength("");
            setmessage("");
            setErrorAlert(false);
        }
        setEditgig2(false);
    };
    const fetchMoreData = (value) => {
        setCurrentPage(currentPage + 1);
        dispatch(
            getJobListing({
                sorttype: sorttype,
                currentPage: currentPage + 1,
                gigType: "Published",
                fetchMore: true,
                pageSize: 20,
                isPrivate: GigType,
            })
        );
        if (publishedJobs?.length == counts?.totalCount[0]?.published) {
            setCurrentPage(1);
            setHasMore(false);
            setTotalLength(true);
        }
    };
    
    const searchHandler = (seacrhText) => {
        let letters = /^[A-Za-z ]+$/;
        if (seacrhText.match(letters) || seacrhText === "") {
            setSearchText(seacrhText);
        }
        var search = searchPublish.filter((item) =>
            item.Title.toLowerCase().includes(seacrhText.toLowerCase())
        );
        if (seacrhText === "") {
            setsearchPublish(publishedJobs);
            if (
                publishedJobs?.length ==
                counts?.totalCount[0]?.expired +
                counts?.totalCount[0]?.published +
                counts?.totalCount[0]?.deleted
            ) {
                setCurrentPage(1);
                setHasMore(false);
            } else {
                if (publishedJobs.length >= 20) {
                    setHasMore(true);
                }
            }
        } else {
            setHasMore(false);
            setFlag(true);
        }
    };
    
    useEffect(() => {
        setsearchPublish(jobs?.publishedGigs);
    }, [jobs?.publishedGigs, props.visible]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const showTaxTermModal = () => {
      setIsModalOpen(true);
    };
    const handleOk = () => {
      setIsModalOpen(false);
    };
    const handleCancel = () => {
      setIsModalOpen(false);
    };
  
    const onChange = (e) => {
      setTaxTermRadio(e.target.value);
    };

    return (
        <div id="infinite-scroll">
           {
            modalType !== ""  &&
            <Modal
            className="mod"
            open={modalType == "Choose a gig" ? false : Editgig2}
            title={
                modalType === "Add Estimated Pay"
                    ? selectedGigDetails?.JobOrderTypes?.JobOrderTypeName == "Permanent"
                        ? "Add Bid Amount"
                        : modalType + " Rate"
                    : modalType
            }
            bodyStyle={{
                padding:
                    modalType === "Choose a gig"
                        ? "15px 5px 15px 5px"
                        : modalType === "Finalize Bid"
                            ? "15px 10px 15px 10px"
                            : "15px 5px 15px 20px",
            }}
            style={{ top: "10px" }}
            onOk={nextHandler}
            onCancel={closemeHandle}
            width={windowDimensions.width < 992 ? "99%" : "60%"}
            footer={
                modalType === "Choose a gig" ? null : (
                    <div className="modalFooterPB">
                        <Button
                            key="back"
                            className="backBtnPlaceBid centerElement textPlaceBid"
                            onClick={backHandler}
                        >
                            Back
                        </Button>
                        <button
                            style={{
                                border: "none",
                                cursor:
                                    !(loadingBidCreate || loadingBidUpdate) &&
                                        rate < props.desired_rate
                                        ? "default"
                                        : "pointer",
                            }}
                            className={`nextBtnPlacedBid nextBtnPlaceBid-nextPadding centerElement textPlacedBid`}
                            onClick={nextHandler}
                        >
                            {loadingBidCreate || loadingBidUpdate ? (
                                <LoadingOutlined />
                            ) : modalType === "Sell your gig" ? (
                                props.EditBid === true ? (
                                    "Update bid"
                                ) : (
                                    "Submit Bid"
                                )
                            ) : modalType === "Finalize Bid" ? (
                                "Done"
                            ) : (
                                "Next"
                            )}
                        </button>
                    </div>
                )
            }
        >
            {errorAlert || createBidError || updateBidError ? (
                <Alert
                    style={{ marginBottom: "1%" }}
                    message="Something went wrong! Try bidding again."
                    type="error"
                />
            ) : null}

            {modalType === "Place a bid" || modalType == "Edit Bid" ? (
                <Row>
                    {props.selectedCandidates?.map((item, index) => {
                        return (
                            <Col
                                xs={12}
                                sm={12}
                                md={12}
                                lg={8}
                                xl={8}
                                style={{ marginBottom: "1%" }}
                                key={Math.random()}
                            >
                                <CandidateCard
                                    img={item.img}
                                    name={item.name}
                                    item={item}
                                    title={item.title}
                                    setSkillListingIds={props?.setSkillListingIds}
                                    skillListingIds={props?.skillListingIds}
                                    setSelectedCandidates={props?.setSelectedCandidates}
                                    setCheckedCandidates={props?.setCheckedCandidates}
                                    checkedCandidates={props?.checkedCandidates}
                                    setSkillSetwithIDsAll={props?.setSkillSetwithIDsAll}
                                    skillSetwithIDsAll={props?.skillSetwithIDsAll}
                                    experience={item.experience}
                                    desired_rate={
                                        item.desired_rate?.$numberDecimal
                                            ? item.desired_rate?.$numberDecimal
                                            : item.desired_rate
                                    }
                                    bidType={item.bidType}
                                    GigType={item.GigType}
                                    profileType={item.profileType}
                                    lastActive={item.lastActive}
                                    closeIcon={true}
                                    rating={item.rating}
                                    reviews={item.reviews}
                                    email={item.email}
                                    userSKillListing={props?.userSKillListing}
                                />
                            </Col>
                        );
                    })}
                </Row>
            ) : null}
            {modalType === "Add Estimated Pay" ? (
                <>
                    <BidAmount
                        desiredRate={
                            professionCode?.Professions?.ProfessionCode !== "IT"
                                ? props?.desired_rate !== null
                                    ? props?.desired_rate
                                    : 1.0
                                : 1.0
                        }
                        rate={rate}
                        setrate={setrate}
                        rateType={rateType}
                        setrateType={setrateType}
                        currencyType={currencyType}
                        multiBid={props.multiBid}
                        extendBilling={props.extendBilling}
                        setRateError={setRateError}
                        EditBid={props.EditBid}
                        Bid_rate={props.Bid_rate}
                        rateError={rateError}
                        professionCode={professionCode?.Professions?.ProfessionCode}
                    />
                    {
                        rateType === "Hour" && (
                            <PayCalculation
                                amount={rate}
                                isPrivateGig={selectedGigDetails?.isPrivate}
                                taxTermRadio={taxTermRadio}
                                permenantGig={selectedGigDetails?.JobOrderTypes?.JobOrderTypeName}
                            />
                        )}
                </>
            ) : null}
            {modalType === "Sell your gig" ? (
                <SellJob
                    setidealStartDate={setidealStartDate}
                    idealStartDate={idealStartDate}
                    setcontractLength={setcontractLength}
                    contractLength={contractLength}
                    message={message}
                    setmessage={setmessage}
                    setMsgCounter={setMsgCounter}
                    error1={error1}
                    error2={error2}
                    error3={error3}
                    setError3={setError3}
                    EditBid={props.EditBid}
                    selectedGigDetails={selectedGigDetails}
                    jobOrderTypeName={
                        selectedGigDetails?.JobOrderTypes?.JobOrderTypeName
                    }
                />
            ) : null}

            {modalType === "Finalize Bid" ? (
                <FinalizeBid
                    rate={rate}
                    rateType={rateType}
                    idealStartDate={idealStartDate}
                    contractLength={contractLength}
                    message={message}
                    candidateList={props.selectedCandidates}
                    selectedGigDetails={selectedGigDetails}
                    jobOrderTypeName={
                        selectedGigDetails?.JobOrderTypes?.JobOrderTypeName
                    }
                    currencyType={currencyType}
                    EditBid={props.EditBid}
                    fromMatches={props.fromMatches}
                    jobdetails={props.jobdetails}
                />
            ) : null}
        </Modal>
           }
            {modalType === "Choose a gig" ||
                (modalType !== "Edit Bid" &&
                    props?.fromDetailPage &&
                    props?.HidePagePvt) ||
                location.pathname == "/editPlaceBidPage" ? (
                <div className="ChooseGig-cantainer-pvt-tal">
                    <div className="ChooseGig-Title-pvt">Choose a gig</div>
                    <div className="ChooseGig-Section-pvt">
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                                <Input
                                    className="chooseJobSearch-placeBid"
                                    style={{
                                        width: windowDimensions.width > 845 && "330px",
                                        marginLeft: windowDimensions.width > 845 && "20px",
                                    }}
                                    type="input"
                                    placeholder="Gig title..."
                                    value={searchText}
                                    prefix={<SearchOutlined className="joblisting-searchicon" />}
                                    onChange={(e) => {
                                        searchHandler(e.target.value);
                                    }}
                                    allowClear
                                />
                            </Col>
                        </Row>
                        <AllGigsFilter setSearchFilters={setSearchFilters} searchFilters={searchFilters} windowDimensions={windowDimensions} handleApplyFilter={handleApplyFilter} searchText={searchText} setGigType={setGigType} GigType={GigType} />
                        {gigAlert ? (
                            <Alert
                                style={{
                                    display: gigAlert ? "" : "none",
                                    width: "97%",
                                    marginBottom: "5px",
                                }}
                                message="Stop Bid Alert"
                                description="You have reached the max bid limit (200 bids per day) for this job for today. Try again tomorrow"
                                type="warning"
                                showIcon
                                closable
                            />
                        ) : null}
                        <InfiniteScroll
                            dataLength={searchPublish?.length ?? 0}
                            next={fetchMoreData}
                            hasMore={hasMore}
                            scrollableTarget={"infinite-scroll"}
                            className={"infinite-scroller-place-bid"}
                            loader={hasMore ? <LoadingOutlined /> : null}
                        >
                            <Row>
                                {jobLoading && searchPublish?.length == 0 ? (
                                    <div
                                        className="emptyOtherSearch"
                                        style={{ marginTop: "30%", fontSize: "25px" }}
                                    >
                                        {" "}
                                        <LoadingOutlined />
                                    </div>
                                ) : searchPublish?.length != 0 ? (
                                    searchPublish?.map((item, index) => {
                                        if (
                                            item.JobOrderStatuses?.JobOrderStatusName !== "Deleted" ||
                                            item.JobOrderStatuses?.JobOrderStatusName !== "Expired" ||
                                            item.JobOrderStatuses.JobOrderStatusName !== "Closed"
                                        )
                                            return (
                                                <Col
                                                    key={index}
                                                    xs={24}
                                                    sm={12}
                                                    md={8}
                                                    lg={8}
                                                    xl={8}
                                                    onClick={() => {
                                                        if (
                                                            item?.status[3]?.count +
                                                            (!props?.multiBid &&
                                                                !props?.EditBid &&
                                                                props?.selectedCandidates[0]?.id != null
                                                                ? 1
                                                                : 0) +
                                                            (props?.multiBid
                                                                ? props?.selectedCandidates?.length
                                                                : 0) >
                                                            200
                                                        ) {
                                                            setGigAlert(true);
                                                            setTimeout(() => {
                                                                setGigAlert(false);
                                                            }, 4000);
                                                        } else {
                                                            setselectedGigDetails(item);
                                                        }
                                                    }}
                                                >
                                                    {
                                                        <div
                                                            className={`jobcard-container ${selectedGigDetails?._id == item?._id
                                                                ? "ChooseGig-selected-card-pvt"
                                                                : null
                                                                }`}
                                                        >
                                                            <JobCard
                                                                {...(item||{})}
                                                                key={item?.JobOrderId}
                                                                img={
                                                                    item?.Regions?.Code !== null &&
                                                                        item?.Cities?.CityName !== null
                                                                        ? getImageByStateCode(
                                                                            item?.Regions?.Code,
                                                                            item?.Cities?.CityName,
                                                                            item?.CompanyName
                                                                        )
                                                                        : ""
                                                                }
                                                                budgetType={item?.BudgetTypes?.BudgetTypeCode}
                                                                RegionCode={item?.Regions?.Code}
                                                                CityName={item?.Cities?.CityName}
                                                                id={item?.JobOrderId}
                                                                location={item.Location?.LocationWithCountry}
                                                                title={item?.Title}
                                                                facilityname={item?.FacilityName}
                                                                budget={item?.BudgetMin}
                                                                rate={item?.BudgetTypes?.BudgetTypeName}
                                                                cardFooter={false}
                                                                cardFooterChoose={true}
                                                                fromDashboard={true}
                                                                professionCode={
                                                                    professionCode?.Professions?.ProfessionCode
                                                                }
                                                                rating={item?.facilityRating?.rating}
                                                                WorkplacePolicy={item?.WorkplacePolicy}
                                                                created={item?.Created}
                                                                matchedbids={item?.status[2]?.count}
                                                                placedbids={item?.status[0]?.count}
                                                                receivedbids={item?.status[1]?.count}
                                                                isPrivate={item?.isPrivate}
                                                                
                                                            />
                                                        </div>
                                                    }
                                                </Col>
                                            );
                                    })
                                ) : (
                                    <div className="emptyOtherSearch">
                                        {flag ? (
                                            <Empty style={{ weight: "100%" }} />
                                        ) : (
                                            <div className="employer-profile-body">
                                                <div
                                                    className="employer-profile-body-content"
                                                    style={{ margin: "10px" }}
                                                >
                                                    <img className="nojobimage" src={noJobs} />
                                                    <div className="nojobtext">
                                                        Create a gig to let candidates know you're hiring!
                                                    </div>
                                                    <button
                                                        className="postajob-btn"
                                                        onClick={() => history.push("/postjob")}
                                                    >
                                                        <span className="postjobbtn_plussign">+</span>
                                                        <span className="postjobbtn_text">Post a gig</span>
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Row>
                        </InfiniteScroll>
                    </div>
                    {
                        <div className="ChooseGigsButton-btn">
                            <ChooseGigsButton
                                ConversationId={props?.selectedCandidates}
                                MessageEditsection={props?.MessageEditsection}
                                path={location.pathname}
                                nextHandler={nextHandler}
                                backHandler={backHandler}
                                selectedGigDetails={selectedGigDetails}
                                SkillListingId={props?.SkillListingId}
                                talentName={talentName}
                            />
                        </div>
                    }
                </div>
            ) : null}
      {
        userProfile?.Professions?.ProfessionCode === "IT" ?
        <div>
        <Modal title={
             <div style={{height:"20px"}}>
              <p style={{fontSize:"16px", fontWeight:"500", color:"#3E3E3E"}}>Choose Tax Term</p>
             </div>
        } 
        footer={[
         <div className='footer-div'>
          <div>
          <Button key="back"  onClick={()=>{
           handleCancel()
           setmodalType("Choose a gig");
           setErrorAlert(false);
           props?.setHidePagePvt(true);
          }} className='cancelBtn'> 
             <span style={{fontSize:"12px", fontWeight:"600"}}>Back</span>
          </Button>,
          </div>
         <div>
         <Button key="submit" type="primary"  onClick={()=>{
           handleCancel()
            setmodalType("Add Estimated Pay");
            setErrorAlert(false);
            props?.setHidePagePvt(false);
         }} className='nextBtn'>
            <span style={{fontSize:"12px", fontWeight:"600"}}>Next</span>
          </Button>
         </div>
         </div>
        ]}
        open={isModalOpen} 
        onCancel={()=>{
         handleCancel()
         setmodalType("Choose a gig");
         setErrorAlert(false);
         props?.setHidePagePvt(true);
        }}
        width={"740px"}
        bodyStyle={{ height: 248 }} >
          <div className='main-div'>
            <div className='left-div'>
                <span className='Tax-term-text'>Tax Term <span className='Mandatory-text'>(Mandatory)</span>
                {
                 windowDimensions.width <=786 ? 
                 <Tooltip placement="bottom" title={
                 <div className="tooltip-div">
                   <ul style={{marginLeft:"15px"}}>
                     <li className="desc-li">
                     W-2: A tax form used by employers to report 
                     employees' annual earnings and tax withholdings to the 
                     IRS.
                     </li>
                     <li className="desc-li">
                     Corp-to-Corp (C2C): An arrangement where one 
                     corporation contracts with another for services, often 
                     used in consulting, with tax responsibilities typically 
                     falling on the contracting corporation.
                     </li>
                   </ul>
                 </div>} 
                 trigger={"click"}
                 overlayStyle={{ width: "auto" }}
                 overlayInnerStyle={{ width: 320, marginTop: "-13px", marginLeft: '-32px',  borderRadius:"6px", paddingTop: "10px"}}
                 >
                 <span style={{ marginLeft:"8px"}}><InfoCircleOutlined style={{color:"#7E7E7E"}}/></span>
               </Tooltip> : ""
                }
                </span>
                <div style={{paddingTop:"10px"}}>
                <Radio.Group accentColor="green" onChange={onChange} defaultValue={"W-2"} buttonStyle="solid">
                    <Radio  value={"W-2"}><span style={{paddingRight:"10px",fontSize:"16px",fontWeight:"400"}}>W-2</span></Radio>
                   <Radio value={"Corp-to-Corp"} style={{paddingTop: 
                   windowDimensions.width <= 786 ? '15px' :""
                   }}><span style={{paddingRight:"10px",fontSize:"16px",fontWeight:"400"}}>Corp-to-Corp</span></Radio>
              </Radio.Group>
                </div>
            </div>
            {
            windowDimensions.width <=786 ? 
            <div style={{width:"500px"}}>
            </div> 
            : 
            <div className='right-div' >
            <div className='Icon-bulb' >
              <img style={{paddingBottom:"6px"}} src={Taxtermicon} alt='empty' />
            </div>
            <div className='desc-box'>
               <ul>
                      <li className='desc-font'>
                      W-2: A tax form used by employers to report employees'
                      annual earnings and tax withholdings to the IRS.
                      </li>
                      <li className='desc-font'>
                      Corp-to-Corp (C2C): An arrangement where one corporation
                       contracts with another for services, often used in consulting, with
                       tax responsibilities typically falling on the contracting corporation.
                      </li>
                    </ul>
                </div>
            </div>
            }
          </div>
        </Modal>
      </div> : ""
      }


        </div>
    );
}



export const ApolloWrapper = ({props}) => {
    const BackendApiBaseUrl = process.env.REACT_APP_API_URL;

    const authTokenValue = useSelector(
        (state) => state.authReducer.user.authToken
    );
    const userProfile = JSON.parse(localStorage.getItem("userProfile"));
    const ImpersonationId = useSelector(
        (state) => state.authReducer.impersonationId
    );

    const httpLink = new HttpLink({
        uri: `${BackendApiBaseUrl}/query`,
    });

    const authLink = setContext((_, { headers }) => {
        if (ImpersonationId) {
            return {
                headers: {
                    ...headers,
                    authorization: authTokenValue ? `${authTokenValue}` : "",
                    email: userProfile?.EmailAddress,
                    impersonationid: ImpersonationId,
                },
            };
        } else {
            return {
                headers: {
                    ...headers,
                    authorization: authTokenValue ? `${authTokenValue}` : "",
                    email: userProfile?.EmailAddress,
                },
            };
        }
    });

    const client = new ApolloClient({
        cache: new InMemoryCache(),
        link: authLink.concat(httpLink),
    });

    return (
        <ApolloProvider client={client}>
            <PlacedBidModalPage {...props} />
        </ApolloProvider>
    );
};
